
export const SITE_ROOT_URL = window.apiBaseUrl;
export const BASE_API_URL = `${SITE_ROOT_URL}/api`;

/*
PAYMENT-api endpoints
*/
export const PAYMENT_API_BASE_URL = `${BASE_API_URL}/payment`;
export const CHECKOUT_API_URL = `${PAYMENT_API_BASE_URL}/InitializePayment`;
export const SET_DELIVERY_METHOD_URL = `${PAYMENT_API_BASE_URL}/deliverymethod`;
export const SET_PAYMENT_METHOD_URL = `${PAYMENT_API_BASE_URL}/paymentmethod`;
export const FINALIZE_PAYMENT_URL = `${PAYMENT_API_BASE_URL}/FinalizePayment`;
export const GET_DELIVERY_METHODS_URL = `${PAYMENT_API_BASE_URL}/deliverymethods`;

/*
PRODUCT-api endpoints
*/
export const PRODUCTS_API_URL = `${BASE_API_URL}/products`;
export const PRODUCT_LIST_API_URL = `${PRODUCTS_API_URL}?productListId=`;

/*
CATEGORY-api endpoints
*/
export const CATEGORY_API_BASE_URL = `${BASE_API_URL}/category`;
export const BRANDS_API_URL = `${CATEGORY_API_BASE_URL}/brands`;
export const DESIGNERS_API_URL = `${CATEGORY_API_BASE_URL}/designers`;

/*
CART-api endpoints
*/
export const CART_API_BASE_URL = `${BASE_API_URL}/shoppingcart`;
export const CART_GET_URL = `${CART_API_BASE_URL}/get`;
export const CART_ADD_URL = `${CART_API_BASE_URL}/add`;
export const CART_REMOVE_URL = `${CART_API_BASE_URL}/remove`;
export const CART_DELETE_URL = `${CART_API_BASE_URL}/delete`;

/*
SEARCH-api endpoints
*/
export const GLOBAL_SEARCH_BASE_API = `${BASE_API_URL}/search`;

/*
CONTENT-api endpoints
*/
export const CONTENT_API_BASE_URL = `${BASE_API_URL}/content`;
export const INSTAGRAM_API_URL = `${CONTENT_API_BASE_URL}/instagram/get`;



// WEBPACK FOOTER //
// ./src/constants/endpoints.js